




import Vue from 'vue';
import OfficialDocumentList from '@/components/official-documents/official-document-list.component.vue';

export default Vue.extend({
  components: {
    'official-document-list': OfficialDocumentList,
  },
});
